import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface PaymentMethodType {
  id?: number;
  paymentMethodTypeId?: number;
  name: string;
  isActive?: boolean;
}

export interface PaymentMethodTypeState {
  paymentMethodTypes: PaymentMethodType[];
  loaded: boolean;
}

const initialState: PaymentMethodTypeState = {
  paymentMethodTypes: [],
  loaded: false,
};

export const paymentMethodTypeSlice = createSlice({
  name: "paymentMethodType",
  initialState,
  reducers: {
    setPaymentMethodTypes(state, action: PayloadAction<PaymentMethodType[]>) {
      state.paymentMethodTypes = action.payload;
      state.loaded = true;
    },
    addOrUpdatePaymentMethodType(
      state,
      action: PayloadAction<PaymentMethodType>,
    ) {
      const item = action.payload;
      const itemId = item.paymentMethodTypeId ?? item.id;
      const idx = state.paymentMethodTypes.findIndex(
        (p) => (p.paymentMethodTypeId ?? p.id) === itemId,
      );
      if (idx >= 0) {
        state.paymentMethodTypes[idx] = item;
      } else {
        state.paymentMethodTypes.push(item);
      }
      state.loaded = true;
    },
    clearPaymentMethodTypes(state) {
      state.paymentMethodTypes = [];
      state.loaded = false;
    },
  },
});

export const {
  setPaymentMethodTypes,
  addOrUpdatePaymentMethodType,
  clearPaymentMethodTypes,
} = paymentMethodTypeSlice.actions;

export const selectPaymentMethodTypes = (state: RootState) =>
  state.paymentMethodType.paymentMethodTypes;

export const selectPaymentMethodTypesLoaded = (state: RootState) =>
  state.paymentMethodType.loaded;

export default paymentMethodTypeSlice.reducer;
